import { render, staticRenderFns } from "./Swap.vue?vue&type=template&id=bd07d61e&"
import script from "./Swap.vue?vue&type=script&lang=js&"
export * from "./Swap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports